import Vue from 'vue'
import VueFire from 'vuefire'
import {
  createPaperRepository
  , createMenuRepository
  , createCompetitionRepository
  , createFlyerRepository
  , createGazetteRepository
  , createPartnerRepository
  , createCallupRepository
  , createTeamRepository
  , createAdminRepository
} from '../api'

Vue.use(VueFire)

const paper = createPaperRepository();
const menu = createMenuRepository();
const competition = createCompetitionRepository();
const flyer = createFlyerRepository();
const gazette = createGazetteRepository();
const partner = createPartnerRepository();
const callup = createCallupRepository();
const team = createTeamRepository();
const admin = createAdminRepository();

export function createStore() {
  return {
    paper,
    menu,
    competition,
    flyer,
    gazette,
    partner,
    callup,
    team,
    admin
  }
}